import { headerMenu, componentMenu, componentCard, componentLabels, componentMessages, componentHeader } from './imports';

export default {
  translations: {
    menuHeader: headerMenu,
    componentMenu: componentMenu,
    componentCard: componentCard,
    componentLabels: componentLabels,
    componentMessages: componentMessages,
    componentHeader: componentHeader
  }
};
